import React from 'react';
import { NavLink } from 'react-router-dom';

export function NumVersions({ value, dependentValues }){
	const { creativeId } = dependentValues || {};

	if(!value){
		return "";
	}

	if(!creativeId) {
		return value;
	}

	return (
		<NavLink to={`creative/${creativeId}/versions/`}>
			<div>{value}</div>
		</NavLink>
	);
}

const NumVersionsCell = {
	width:120,
	sortable:true,
	resizable:true,
	cellClass: "link-cell",
	formatter: NumVersions,
};

export default NumVersionsCell;
